import React, { useEffect, useState } from 'react'
import Container from '../../../../components/Container'
import { FormRoute } from '../components/CreateForm'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools/create'
import { StringParam, useQueryParam } from 'use-query-params'
import { apiGetByIdUpdatePage } from '../domain/api'
import api from '../../../../services/api'
import { useLoading } from '../../../../hooks/loading'
import { useToast } from '../../../../hooks/toast'

const RouteCreate = (): JSX.Element => {
  const [routeIdQuery] = useQueryParam('route_id', StringParam)
  const { activeLoading, disableLoading } = useLoading()
  const { addToast } = useToast()

  const [routeItem, setRouteItem] = useState()

  useEffect(() => {
    if (!routeIdQuery) return

    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiGetByIdUpdatePage(routeIdQuery))
        const { data } = response
        setRouteItem(data)
        disableLoading()
      } catch (err) {
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar a rota',
          description:
            'Houve um error ao carregar a rota, tente novamente mais tarde!'
        })
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, routeIdQuery])

  return (
    <Container
      pageTitle={nameActions.create.name}
      breadcrumb={breadcrumbCreate}
      tools={toolsCreate}
    >
      <FormRoute initialValues={routeItem} />
    </Container>
  )
}

export default RouteCreate
